export default __webpack_public_path__ + "static/media/Yolanda_Haripersad_AHV_In_Moms_We_Trust.a17a203b.jpg";